<template>
  <div>
    <!-- 구역 관리 모달 시작 -->
    <b-modal
      v-model="modalValue"
      size="xl"
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <div class="card card-custom card-stretch">
      <!--begin::Header-->
      <div class="card-header border-0 align-items-center">
        <h3 class="card-title align-items-start flex-column">
          <span  class="title font-weight-bold">
            {{ i18n.sectionManagement }}
          </span>
        </h3>
        <div class="card-toolbar toolbar-symbol">
          <b-button variant="dark" class="btn-icon rounded-lg" size="sm" @click="modalValue = false">
            <i class="la la-close font-size-h5"></i>
          </b-button>
        </div>
      </div>
      <!--end::Header-->
      <!-- begin::Body -->
      <div class="performance-tabs">
        <b-tabs style="padding-left: 3.077rem;">
          <b-tab v-for="(item, i) in rackPerformanceContent" :key="i" :active="i == rackPerformanceState" @click="changeRackPerformanceConnect(item.state)">
            <template slot="title">
              <span class="nav-text font-weight-bold font-size-h6 font-size-h4-lg">{{ item.text }}</span>
            </template>
          </b-tab>
        </b-tabs>
      </div>
      <div class="card-body pt-5">
        <!-- 구역 추가 -->
        <div v-show="rackPerformanceState === 0">
          <div class="form-group row mb-4">
            
            <label class="col-sm-2 col-form-label">
              <span class="h5">{{i18n.sectionName}}</span>
            </label>
            <div class="col-sm-4">
              <input v-model="sectionRack.rackGroupName" type="text" maxlength="30" class="farm-form-control form-control">
            </div>
            <label class="col-sm-2 col-form-label">
              <span class="h5">{{i18n.plantingTotalCapa}}</span>
            </label>
            <div class="col-sm-4">
              <input v-model="sectionRack.plantingTotalCapa" @input="limitNumberObject('sectionRack','plantingTotalCapa', 6)" type="number" class="farm-form-control form-control">
            </div>
          </div>
          <div class="form-group row mb-4 scrollable-sticky" style="display: block;" >
            <label class="col-sm-2 col-form-label">
              <span class="h5">{{i18n.selectRack}}</span>
            </label>
            <div class="col-sm-4" style="max-width:100%">
              <div class="farm-form-control form-control disabled-gray scrollable-text">
                {{ selectRackList.allRacks.map(item => item.rackLocation).join(', ') }}
              </div>
            </div>
          </div>
          <div class="form-group row mb-4" style="display: block;">
            <div class="form-inline col-xxl-2 col-lg-4 mb-3">
              <label class="col-form-label">
                <span class="h5">{{i18n.rack}}</span>
              </label>
              <div class="col-sm-4">
                <b-form-select v-model="connect.rackConnect" 
                  :options="connect.connectNmList" 
                  class="disabled-white"
                  @change="cropRackConnect()">
                </b-form-select>
              </div>
            </div>
            <div class="col-sm-4" style="max-width:100%">
              <v-data-table
                :headers="rackColumn"
                :items="rackList.allRacks"
                item-key="farmRackNo"
                class="elevation-1 farm-data-table"
                :no-data-text="`${i18n.noData}`"
                hide-default-footer
                single-expand
                @click:row="rackClick"
                style="cursor: pointer;"
                :items-per-page="-1"
              >
              <!-- 바디 -->
              </v-data-table>
              <!--begin::pagination-->
              <div class="pagination mt-12">
                <b-pagination
                  :total-rows="rackPaging.totalCount"
                  v-model="rackPaging.pageNo"
                  :per-page = "rackPaging.pageSize"
                  limit="10"
                >
                  <template #first-text><i class="fas fa-angle-double-left"></i></template>
                  <template #prev-text><i class="fas fa-angle-left"></i></template>
                  <template #next-text><i class="fas fa-angle-right"></i></template>
                  <template #last-text><i class="fas fa-angle-double-right"></i></template>
                  <template #page="{ page, active }">
                    <span v-if="active" class="font-size-sm font-weight-bold text-white">{{ page }}</span>
                    <span v-else class="font-size-sm font-weight-bold text-dark">{{ page }}</span>
                  </template>
                </b-pagination>
              </div>
            <!--end::pagination-->
            </div>
          </div>  
        </div>
        <!-- 구역 수정 -->
        <div v-show="rackPerformanceState === 1">
          <div class="form-group row mb-4" style="display: block;">
            <label class="col-sm-2 col-form-label">
              <span class="h5">{{i18n.section}}</span>
            </label>
            <div class="col-sm-4" style="max-width:100%">
              <v-data-table
                :headers="rackGroupColumn"
                :items="rackGroupList.rackGroupList"
                item-key="rackGroupNo"
                class="elevation-1 farm-data-table"
                :no-data-text="`${i18n.noData}`"
                hide-default-footer
                single-expand
                @click:row="rackGroupUpdateRowClick"
                style="cursor: pointer;"
                :items-per-page="-1"
              >
              <!-- 바디 -->
              </v-data-table>
              <!--begin::pagination-->
              <div class="pagination mt-12">
                <b-pagination
                  :total-rows="rackGroupPaging.totalCount"
                  v-model="rackGroupPaging.pageNo"
                  :per-page = "rackGroupPaging.pageSize"
                  limit="10"
                >
                  <template #first-text><i class="fas fa-angle-double-left"></i></template>
                  <template #prev-text><i class="fas fa-angle-left"></i></template>
                  <template #next-text><i class="fas fa-angle-right"></i></template>
                  <template #last-text><i class="fas fa-angle-double-right"></i></template>
                  <template #page="{ page, active }">
                    <span v-if="active" class="font-size-sm font-weight-bold text-white">{{ page }}</span>
                    <span v-else class="font-size-sm font-weight-bold text-dark">{{ page }}</span>
                  </template>
                </b-pagination>
              </div>
            <!--end::pagination-->
            </div>
          </div>
        </div>  
        <!-- 랙 추가 -->
        <div v-show="rackPerformanceState === 2">
          <div class="form-group row mb-4">
            <label class="col-sm-2 col-form-label">
              <span class="h5">{{i18n.controllerName}}</span>
            </label>
            <div class="col-sm-4">
              <b-form-select v-model="addRack.systemId" 
                :options="connect.connectNmList" 
                class="disabled-white"
              >
              </b-form-select>
            </div>
            <label class="col-sm-2 col-form-label">
              <span class="h5">{{i18n.rackNm}}</span>
            </label>
            <div class="col-sm-4">
              <input v-model="addRack.rackLocation" type="text" maxlength="30" class="farm-form-control form-control" placeholder="ex) A1, A2, B1...">
            </div>
          </div>
          <div class="form-group row mb-4">
            <label class="col-sm-2 col-form-label">
              <span class="h5">{{i18n.rackRowCount}}</span>
            </label>
            <div class="col-sm-4">
              <input v-model="addRack.rackRow" @input="limitNumberObject('addRack','rackRow', 6)" type="number" class="farm-form-control form-control">
            </div>
            <label class="col-sm-2 col-form-label">
              <span class="h5">{{i18n.rackColumnCount}}</span>
            </label>
            <div class="col-sm-4">
              <input v-model="addRack.rackColumn" @input="limitNumberObject('addRack','rackColumn', 6)" type="number" class="farm-form-control form-control">
            </div>
          </div>
          <div class="form-group row mb-4">
            <label class="col-sm-2 col-form-label">
              <span class="h5">{{i18n.potCount}}</span>
            </label>
            <div class="col-sm-4">
              <input v-model="addRack.potCount" @input="limitNumberObject('addRack','potCount', 6)" type="number" class="farm-form-control form-control">
            </div>
          </div>
        </div>
        <!-- 랙 수정 -->
        <div v-show="rackPerformanceState === 3">
          <div class="form-group row mb-4">
            <label class="col-sm-2 col-form-label">
              <span class="h5">{{i18n.controllerName}}</span>
            </label>
            <div class="col-sm-4">
              <b-form-select v-model="connect.rackConnect" 
                :options="connect.connectNmList" 
                class="disabled-white"
                @change="cropRackConnect()"
              >
              </b-form-select>
            </div>
          </div>
          <div class="form-group row mb-4" style="display: block;">
            <label class="col-sm-2 col-form-label">
              <span class="h5">{{i18n.rack}}</span>
            </label>
            <div class="col-sm-4" style="max-width:100%">
              <v-data-table
                :headers="rackColumn"
                :items="rackList.allRacks"
                item-key="farmRackNo"
                class="elevation-1 farm-data-table"
                :no-data-text="`${i18n.noData}`"
                hide-default-footer
                single-expand
                @click:row="updateRackClick"
                style="cursor: pointer;"
                :items-per-page="-1"
              >
              </v-data-table>
              <!--begin::pagination-->
              <div class="pagination mt-12">
                <b-pagination
                  :total-rows="rackPaging.totalCount"
                  v-model="rackPaging.pageNo"
                  :per-page = "rackPaging.pageSize"
                  limit="10"
                >
                  <template #first-text><i class="fas fa-angle-double-left"></i></template>
                  <template #prev-text><i class="fas fa-angle-left"></i></template>
                  <template #next-text><i class="fas fa-angle-right"></i></template>
                  <template #last-text><i class="fas fa-angle-double-right"></i></template>
                  <template #page="{ page, active }">
                    <span v-if="active" class="font-size-sm font-weight-bold text-white">{{ page }}</span>
                    <span v-else class="font-size-sm font-weight-bold text-dark">{{ page }}</span>
                  </template>
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--begin::Footer-->
          <div class="card-footer">
            <b-button v-if="rackPerformanceState === 0" variant="primary" size="lg" @click="insertRackGroup()"><span >{{ i18n.sectionRegistration }}</span></b-button>
            <b-button v-if="rackPerformanceState === 2" variant="primary" size="lg" @click="insertRack()"><span >{{ i18n.addRack }}</span></b-button>
          </div>
      <!--end::Footer-->
      </div>

    </b-modal>
    <!-- 구역 관리 모달 종료 -->
    
    <!-- 구역 수정 모달 시작-->
    <b-modal
      v-model="sectionUpdateModal"
      size="xl"
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <div class="card card-custom card-stretch">
      <!--begin::Header-->
      <div class="card-header border-0 align-items-center">
        <h3 class="card-title align-items-start flex-column">
          <span  class="title font-weight-bold">
            {{ i18n.sectionUpdate }}
          </span>
        </h3>
        <div class="card-toolbar toolbar-symbol">
          <b-button variant="dark" class="btn-icon rounded-lg" size="sm" @click="sectionUpdateModal = false">
            <i class="la la-close font-size-h5"></i>
          </b-button>
        </div>
      </div>
      <!--end::Header-->
      <!-- begin::Body -->
      <div class="card-body pt-5">
        <div class="form-group row mb-4">
            
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.sectionName}}</span>
          </label>
          <div class="col-sm-4">
            <input v-model="sectionRack.rackGroupName" type="text" maxlength="30" class="farm-form-control form-control">
          </div>
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.plantingTotalCapa}}</span>
          </label>
          <div class="col-sm-4">
            <input v-model="sectionRack.plantingTotalCapa" @input="limitNumberObject('sectionRack','plantingTotalCapa', 6)" type="number" class="farm-form-control form-control">
          </div>
        </div>
        <div class="form-group row mb-4 scrollable-sticky" style="display: block;" >
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.selectRack}}</span>
          </label>
          <div class="col-sm-4" style="max-width:100%">
            <div class="farm-form-control form-control disabled-gray scrollable-text">
              {{ selectRackList.allRacks.map(item => item.rackLocation).join(', ') }}
            </div>
          </div>
        </div>
        <div class="form-group row mb-4" style="display: block;">
          <div class="form-inline col-xxl-2 col-lg-4 mb-3">
            <label class="col-form-label">
              <span class="h5">{{i18n.rack}}</span>
            </label>
            <div class="col-sm-4">
              <b-form-select v-model="connect.rackConnect" 
                :options="connect.connectNmList" 
                class="disabled-white"
                @change="cropRackConnect()">
              </b-form-select>
            </div>
          </div>
          <div class="col-sm-4" style="max-width:100%">
            <v-data-table
              :headers="rackColumn"
              :items="rackList.allRacks"
              item-key="farmRackNo"
              class="elevation-1 farm-data-table"
              :no-data-text="`${i18n.noData}`"
              hide-default-footer
              single-expand
              @click:row="rackClick"
              style="cursor: pointer;"
              :items-per-page="-1"
            >
            <!-- 바디 -->
            </v-data-table>
            <!--begin::pagination-->
            <div class="pagination mt-12">
              <b-pagination
                :total-rows="rackPaging.totalCount"
                v-model="rackPaging.pageNo"
                :per-page = "rackPaging.pageSize"
                limit="10"
              >
                <template #first-text><i class="fas fa-angle-double-left"></i></template>
                <template #prev-text><i class="fas fa-angle-left"></i></template>
                <template #next-text><i class="fas fa-angle-right"></i></template>
                <template #last-text><i class="fas fa-angle-double-right"></i></template>
                <template #page="{ page, active }">
                  <span v-if="active" class="font-size-sm font-weight-bold text-white">{{ page }}</span>
                  <span v-else class="font-size-sm font-weight-bold text-dark">{{ page }}</span>
                </template>
              </b-pagination>
            </div>
          <!--end::pagination-->
          </div>
        </div>  
      </div>
      <!--begin::Footer-->
      <div class="card-footer">
        <b-button variant="primary" size="lg" @click="updateRackGroup()"><span >{{ i18n.sectionUpdate }}</span></b-button>
        <b-button variant="secondary" size="lg" class="ml-3" @click="deleteRackGroup()"><span >{{ i18n.sectionDelete }}</span></b-button>
      </div>
      <!--end::Footer-->
      </div>
    </b-modal>
    <!-- 구역 수정 모달 종료-->

    <!-- 랙 수정 모달 시작 -->
    <b-modal
      v-model="rackUpdateModal"
      size="xl"
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <div class="card card-custom card-stretch">
      <!--begin::Header-->
      <div class="card-header border-0 align-items-center">
        <h3 class="card-title align-items-start flex-column">
          <span  class="title font-weight-bold">
            {{ i18n.updateRack }}
          </span>
        </h3>
        <div class="card-toolbar toolbar-symbol">
          <b-button variant="dark" class="btn-icon rounded-lg" size="sm" @click="rackUpdateModal = false">
            <i class="la la-close font-size-h5"></i>
          </b-button>
        </div>
      </div>
      <!--end::Header-->
      <!-- begin::Body -->
      <div class="card-body pt-5">
        <div class="form-group row mb-4">
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.controllerName}}</span>
          </label>
          <div class="col-sm-4">
            <b-form-select v-model="addRack.systemId" 
              :options="connect.connectNmList">
            </b-form-select>
          </div>
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.rackNm}}</span>
          </label>
          <div class="col-sm-4">
            <input v-model="addRack.rackLocation" type="text" maxlength="30" class="farm-form-control form-control" placeholder="ex) A1, A2, B1...">
          </div>
        </div>
        <div class="form-group row mb-4">
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.rackRowCount}}</span>
          </label>
          <div class="col-sm-4">
            <input v-model="addRack.rackRow" type="number" @input="limitNumberObject('addRack','rackRow', 6)" class="farm-form-control form-control">
          </div>
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.rackColumnCount}}</span>
          </label>
          <div class="col-sm-4">
            <input v-model="addRack.rackColumn" type="number" @input="limitNumberObject('addRack','rackColumn', 6)" class="farm-form-control form-control">
          </div>
        </div>
        <div class="form-group row mb-4">
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.potCount}}</span>
          </label>
          <div class="col-sm-4">
            <input v-model="addRack.potCount" type="number" @input="limitNumberObject('addRack','potCount', 6)" class="farm-form-control form-control">
          </div>
        </div>
      </div>
      <!--begin::Footer-->
      <div class="card-footer">
        <b-button variant="primary" size="lg" @click="updateRack()"><span >{{ i18n.updateRack }}</span></b-button>
        <b-button variant="secondary" size="lg" class="ml-3" @click="deleteRack()"><span >{{ i18n.deleteRack }}</span></b-button>
      </div>
      <!--end::Footer-->
      </div>
    </b-modal>
    <!-- 랙 수정 모달 종료 -->

  </div>
</template>
<script>
  import Vue from "vue";
  import i18n from '@/core/plugins/vue-i18n.js';
  import {
    ACT_GET_MY_FARM_RACK,
    ACT_SET_YIELD_RACK_GROUP,
    ACT_GET_YIELD_RACK_GROUP,
    ACT_INSERT_MY_FARM_RACK,
    ACT_UPDATE_YIELD_RACK_GROUP,
    ACT_DELETE_YIELD_RACK_GROUP,
    ACT_UPDATE_MY_FARM_RACK,
    ACT_DELETE_MY_FARM_RACK
  } from '@/core/services/variable';
  import {Rack, RackList, RackConnect, RackGroupList, SectionRack, RackGroup} from '@/view/model/RackModel.js'
  import {isSuccess, getResult, lan} from '@/core/services/funcs';
  import {ACT_ADD_ALERT, ACT_SHOW_CONFIRM_ALERT} from '@/core/services/store/alert.module';
  import {Paging} from '@/view/model/PagingModel.js'


  export default {
    
    props: {
      rackManagementModal: Boolean,
      farmInfo: Object,
    },
    computed: {
      modalValue: {
        get() {
          return this.rackManagementModal;
        },
        set(value) {
          this.$emit("rackManagementModalUpdate", value);
        },
      },
    },
    watch:{
      "rackPaging.pageNo"(newPage) {
        this.getRack()
      },
      "rackGroupPaging.pageNo"(newPage) {
        this.getRackGroup()
      },
      // 모달 on/off
      rackManagementModal(value) {
        if(value){
          this.rackPerformanceState = 0
          this.rackPaging.pageNo = 1
          this.rackGroupPaging.pageNo = 1

          this.init()
        }
      }
    },
    data() {
      return {
        i18n : {
          rackManagement: i18n.t('farm.yield.rackManagement'), // 랙 관리
          sectionName: i18n.t('farm.yield.sectionName'), // 구역 이름 
          sectionUpdate: i18n.t('farm.yield.sectionUpdate'), // 구역 수정 
          sectionDelete: i18n.t('farm.yield.sectionDelete'), // 구역 삭제
          plantingTotalCapa: i18n.t('farm.yield.plantingTotalCapa'), // 사용 총 Capa 
          selectRack: i18n.t('farm.yield.selectRack'), // 선택 랙
          rack: i18n.t('farm.yield.rack'), // 랙
          sectionRegistration : i18n.t('farm.yield.sectionRegistration'), // 구역추가 버튼
          sectionManagement: i18n.t('farm.yield.sectionManagement'), // 구역 관리
          controllerName: i18n.t('farm.yield.controllerName'), // 제어기명
          rackNm: i18n.t('farm.yield.rackNm'), // 랙 이름
          rackRowCount: i18n.t('farm.yield.rackRowCount'), // 랙 단수
          rackColumnCount: i18n.t('farm.yield.rackColumnCount'), // 랙 열수
          potCount : i18n.t('farm.yield.potCount'), // 포트수
          addRack: i18n.t('farm.yield.addRack'), // 랙 추가
          updateRack: i18n.t('farm.yield.updateRack'), // 랙 수정
          deleteRack: i18n.t('farm.yield.deleteRack'), // 랙 삭제
          // 오류창
          rightValue: i18n.t('farm.yield.rightValue'),
          confirm: i18n.t('farm.yield.confirm'),

          error: i18n.t('farm.yield.error'),
          deleteAlert: i18n.t('farm.yield.deleteAlert'),

          noData: i18n.t('farm.yield.noData'),
        },
        // 랙 컬럼
        rackColumn: [
          { value: 'rackLocation', text: i18n.t('farm.yield.rackNm'), span: 'col', number: 1, width: '80px' }, // 랙 이름
          { value: 'rackRow', text: i18n.t('farm.yield.rackRowCount'), span: 'col', number: 1, width: '150px' }, // 랙 단 수
          { value: 'rackColumn', text: i18n.t('farm.yield.rackColumnCount'), span: 'col', number: 1}, // 랙 열 수
          { value: 'potCount', text: i18n.t('farm.yield.potCount'), span: 'col', number: 1}, // 포트 수
          { value: 'connectNm', text: i18n.t('farm.yield.controllerName'), span: 'col', number: 1}, // 제어기 이름
        ],
        // 랙 선택에서 사용하는 탭
        rackPerformanceContent: [
          {text: i18n.t('farm.yield.sectionRegistration'), state: 0},
          {text: i18n.t('farm.yield.sectionUpdate'), state: 1},
          {text: i18n.t('farm.yield.addRack'), state: 2},
          {text: i18n.t('farm.yield.updateRack'), state: 3}
        ],
        rackGroupColumn: [
          { value: 'rackGroupName', text: i18n.t('farm.yield.sectionName'), width: '80px' },
          { value: 'rackLocation', text: i18n.t('farm.yield.section'), width: '150px'},
          { value: 'plantingTotalCapa', text: i18n.t('farm.yield.plantingTotalCapa'), width: '30px' },
        ],
        rackPerformanceState: 0,
        sectionRack : new SectionRack(), // 구역 정보
        selectRackList : new RackList(), // 선택 랙 정보저장
        connect : new RackConnect(),
        rackList : new RackList(),
        rackPaging : new Paging(),
        rackGroupList : new RackGroupList(),
        rackGroupPaging : new Paging(),
        addRack : new Rack(),
        sectionUpdateModal : false, // 구역 수정 모달
        rackUpdateModal : false,  // 랙 수정 모달

      }
    },
    created() {
      // this.init()
    },
    
    methods : {
      init() {
        this.sectionRack.init()
        this.getRack()
        this.selectConnect()
        this.getRackGroup()
        this.selectRackList.allRacks = []
        
      },
      // 제어기 조회
      selectConnect(){
        this.connect.connectNmList = []
        this.connect.rackConnect = 0;
        
        let connectList = []
        this.farmInfo.farmConnects.forEach((item)=>{
          // 랙에 연결되 제어기 등록
          connectList.push({value:item.systemId ,text: item.connectNm})
            
        })
        connectList.unshift({value:0, text:`${i18n.t('farm.yield.all')}`}) // 제어기 전체문구 넣기
        this.connect.connectNmList = connectList
      },
      // 랙 관리에서 랙 row클릭
      updateRackClick(value){
        this.rackUpdateModal = true
        this.addRack.updateRackValue(value)
      },
      // 랙 등록
      insertRack(){
        this.addRack.fno = this.farmInfo.fno

        // 유효성 검증
        if(this.addRack.insertValidation() === 1){
          // 오류창
          this.errorMsg()
          return
        }

        this.$store.dispatch(ACT_INSERT_MY_FARM_RACK, this.addRack).then(resp => {
          if(isSuccess(resp)){
            this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage, color: 'success'});
            this.getRackGroup() 
          }else{
            this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
          }
        })
      },
      // 랙 수정 
      updateRack(){
        this.addRack.fno = this.farmInfo.fno

        // 유효성 검증
        if(this.addRack.updateValidation() === 1){
          // 오류창
          this.errorMsg()
          return
        }
        
        this.$store.dispatch(ACT_UPDATE_MY_FARM_RACK, {rno : this.addRack.farmRackNo, params : this.addRack}).then(resp => {
          if(isSuccess(resp)){
            this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage, color: 'success'});
            this.connect.rackConnect = 0
            this.rackUpdateModal = false
            this.getRack()
            // this.getYieldManagement()
            
          }else{
            this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
          }
        })
      },
      // 랙 삭제
      deleteRack() {

        const yesCallback = () => {

          this.$store.dispatch(ACT_DELETE_MY_FARM_RACK, this.addRack.farmRackNo).then(resp => {
            if(isSuccess(resp)){
              this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage, color: 'success'});
              this.connect.rackConnect = 0
              this.rackUpdateModal = false
              this.getRack()
              // this.getYieldManagement()
              
            }else{
              this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
            }
          }).catch(e => {
            console.error(e);
            this.$store.dispatch(ACT_ADD_ALERT, {message: this.i18n.error});
          });
        }

        this.$store.dispatch(ACT_SHOW_CONFIRM_ALERT, {
          info: {title: this.i18n.deleteAlert},
          callback: yesCallback
        })
      },
      // 랙 조회
      getRack(){

        const params = {
          pageNo : this.rackPaging.pageNo,
          pageSize: this.rackPaging.pageSize,
          systemId: this.connect.rackConnect === 0 ? null : this.connect.rackConnect
        }
        this.$store.dispatch(ACT_GET_MY_FARM_RACK, {fno: this.farmInfo.fno, params: params}).then(resp => {
          
          this.rackPaging.totalCount = resp.paging.totalCount
          // 랙의 모든 데이터
          this.rackList.allRacks = []
          resp.items.map(data => this.rackList.addRack(Rack.objectRack(data)));
        })
      },
      // 랙 선택 로우 클릭
      rackClick(item) {
        // 리스트에서 이미 있는지 확인
        const index = this.selectRackList.allRacks.findIndex(
          rack => Number(rack.farmRackNo) === Number(item.farmRackNo)
        );

        if (index !== -1) {
          // 이미 있으면 제거
          this.selectRackList.allRacks.splice(index, 1);
          if(this.selectRackList.allRacks.length === 0) {
          this.selectRackList.allRacks = []
          }
        } else {
          // 없으면 추가
          this.selectRackList.addRack(Rack.objectRack(item))
        }
        
      },
      // 랙 그룹 등록
      insertRackGroup(){
        
        this.sectionRack.farmRackList = []

        this.selectRackList.allRacks.forEach(item => {
          this.sectionRack.farmRackList.push(item)
        })
        
        // 유효성 검증
        if(this.sectionRack.insertValidate()) {
          this.errorMsg()
          return
        }

        this.$store.dispatch(ACT_SET_YIELD_RACK_GROUP, this.sectionRack.request()).then(resp => {
          if(isSuccess(resp)){
            this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage, color: 'success'});
            this.modalValue = false
            
          }else{
            this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
          }
        })
      },
      // 구역 수정
      updateRackGroup(){
        this.sectionRack.farmRackList = []
        this.selectRackList.allRacks.forEach(item => {
          this.sectionRack.farmRackList.push(item)
        })
        // 유효성 검증
        if(this.sectionRack.insertValidate()) {
          this.errorMsg()
          return
        }

        this.$store.dispatch(ACT_UPDATE_YIELD_RACK_GROUP, {rackGroupNo : this.sectionRack.rackGroupNo, params : this.sectionRack.request()}).then(resp => {
          if(isSuccess(resp)){
            this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage, color: 'success'});
            this.sectionUpdateModal = false
            this.getRackGroup()
            
          }else{
            this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
          }
        })
      },
      // 구역 삭제
      deleteRackGroup(){

        const yesCallback = () => {

          this.$store.dispatch(ACT_DELETE_YIELD_RACK_GROUP, this.sectionRack.rackGroupNo).then(resp => {
            if(isSuccess(resp)){
              this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage, color: 'success'});

              this.sectionUpdateModal = false
              this.getRackGroup()
              
            }else{
              this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
            }
          }).catch(e => {
            console.error(e);
            this.$store.dispatch(ACT_ADD_ALERT, {message: this.i18n.error});
          });
        }

        this.$store.dispatch(ACT_SHOW_CONFIRM_ALERT, {
          info: {title: this.i18n.deleteAlert},
          callback: yesCallback
        })
      },
      // 구역수정 row클릭
      rackGroupUpdateRowClick(item){
        this.sectionUpdateModal = true

        this.sectionRack.init()
        this.selectRackList.allRacks = []
        this.connect.rackConnect = 0
        this.getRack()

        this.sectionRack.rackGroupNo = item.rackGroupNo
        
        this.sectionUpdateModal = true
        this.sectionRack.rackGroupName = item.rackGroupName
        this.sectionRack.plantingTotalCapa = item.plantingTotalCapa
        const rackNoList = item.farmRackNo.split(",").map(item => item.trim());
        const rackLocationList = item.rackLocation.split(",").map(item => item.trim());
        for(let i = 0; i < rackNoList.length; i++){
          const rack = {
            farmRackNo : rackNoList[i],
            batchCode : null,
            connectNm : null,
            fno : null,
            growType : null,
            mno : null,
            potCount : null,
            rackColumn : null,
            rackLocation : rackLocationList[i],
            rackRow : null,
            systemId : null
          }
          this.selectRackList.addRack(Rack.objectRack(rack))
        }
      },
      // 랙 그룹 조회
      getRackGroup(){
        const params = {
          fno: this.farmInfo.fno,
          pageNo : this.rackGroupPaging.pageNo,
          pageSize: this.rackGroupPaging.pageSize
        }
        this.$store.dispatch(ACT_GET_YIELD_RACK_GROUP, params).then(resp => {
          this.rackGroupPaging.totalCount = resp.paging.totalCount
          // 랙의 모든 데이터
          this.rackGroupList.rackGroupList = []
          resp.items.map(data => this.rackGroupList.addRackGroup(RackGroup.objectRackGroup(data)));
          
        })
      },
      // 랙 탭 선택
      changeRackPerformanceConnect(i){
        this.rackPerformanceState = i
        this.rackPaging.pageNo = 1
        this.rackGroupPaging.pageNo = 1
        // 구역추가, 랙 수정
        if(i === 0 || i === 3){
          this.connect.rackConnect = 0
          this.sectionRack.init()
          this.selectRackList.allRacks = []
          this.getRack()
        
        // 구역 수정
        } else if(i === 1){
          this.getRackGroup()
        // 랙 추가
        } else if(i === 2){
          this.addRack.init()
        }
        
        
        
      },
      sectionUpdateModalUpdate(value) {
        this.sectionUpdateModal = value
      },
      // 오류창
      errorMsg(){
        let info = {}
        info.title = this.i18n.rightValue
        info.icon = 'error'
        info.focusConfirm = true
        info.confirmButtonColor = '#131628'
        info.confirmButtonText = this.i18n.confirm
        Vue.swal.fire(info)
      },
      // 숫자수 제한
      limitNumberObject(model,key, limitValue) {
        if(this[model][key].length >= limitValue) {
          this[model][key] = this[model][key].slice(0,limitValue)
        }
      },
      // 랙 드롭다운
      cropRackConnect(){
        this.getRack()
        this.rackPaging.pageNo = 1
      },
    }
  }
</script>

<style scoped lang="scss">
  // 비활성화 색
  .disabled-gray {
    background-color : #e9ecef !important;
  }
  // 활성화 색
  .disabled-white {
    background-color : white !important;
  }

  // 정식구역 스크롤바
  .scrollable-text {
    white-space: nowrap;        /* 텍스트 줄바꿈 방지 */
    overflow-x: auto;          /* X축 스크롤 활성화 */
    overflow-y: hidden;        /* Y축 스크롤 비활성화 */
    max-width: 100%;           /* 부모 요소의 너비 제한 */
    display: flex;             /* Flexbox 사용 */
    align-items: center;       /* 세로 가운데 정렬 */
    padding: 5px;              /* 내부 여백 추가 */
    box-sizing: border-box;    /* 여백과 테두리 포함 */
  }
  /* 스크롤바 스타일 */
  .scrollable-text::-webkit-scrollbar {
    height: 6px;               /* 스크롤바 높이 */
  }
  .scrollable-text::-webkit-scrollbar-thumb {
    background: #888;          /* 스크롤바 색상 */
    border-radius: 3px;        /* 스크롤바 모서리 둥글게 */
  }
  .scrollable-text::-webkit-scrollbar-thumb:hover {
    background: #555;          /* 마우스 오버 시 색상 변경 */
  }
  .scrollable-text::-webkit-scrollbar-track {
    background: #f1f1f1;       /* 스크롤바 트랙 색상 */
  }
  .scrollable-sticky {
    position: sticky;          /* 스크롤 시 고정 */
    top: 0;                    /* 화면 상단에 고정 */
    z-index: 10;               /* 다른 요소보다 위에 표시되도록 설정 */
  }
  // 텍스트 넘침 줄바꿈
  span.h5 {
    white-space: normal;
  }
</style>